import './medinfocard.css';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { useState, useEffect } from 'react';
import { IMedList } from '../../types/type';
import MedList from '../MedList/MedList';
import { MedicalService } from '../../services/medical.service';
import Pagination from '../Pagination/Pagination';

function MedInfoCard({ driverProfileId }: { driverProfileId: string }) {
  const { data } = useSelector((state: RootState) => state.meddata);

  // Состояние для хранения истории медосмотров
  const [medicalHistory, setMedicalHistory] = useState<IMedList[]>([]);

  // Состояние для пагинации
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
  });

  // Состояние загрузки
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  // Функция для получения данных медосмотров
  const fetchMedicalHistory = async (page = 1) => {
    if (!driverProfileId) return;

    setLoading(true);
    setError(null);

    try {
      const response = await MedicalService.getDriverMedLists(driverProfileId, {
        page,
        limit: 5, // Показываем по 5 записей на странице
      });

      setMedicalHistory(response.data);
      setPagination({
        currentPage: response.page,
        totalPages: response.totalPages,
        totalCount: response.totalCount,
      });
    } catch (err: any) {
      console.error('Ошибка при загрузке истории медосмотров:', err);
      setError(err.message || 'Не удалось загрузить историю медосмотров');
    } finally {
      setLoading(false);
    }
  };

  // Функция для изменения страницы
  const handlePageChange = (newPage: number) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      fetchMedicalHistory(newPage);
    }
  };

  // Загружаем данные при изменении ID водителя
  useEffect(() => {
    if (driverProfileId) {
      fetchMedicalHistory(1);
    }
  }, [driverProfileId]);

  // Используем ID водителя из data как запасной вариант, если driverProfileId не передан
  useEffect(() => {
    if (!driverProfileId && data?.driverID) {
      fetchMedicalHistory(1);
    }
  }, [data?.driverID, driverProfileId]);

  return (
    <div className="medinfocard">
      <div className="infoCard">
        <div className="infoCardHeader">
          <div className="infoCardHeaderTitle">История</div>
        </div>

        <div className="medlistsContainer">
          {loading ? (
            <div className="loading-indicator">Загрузка...</div>
          ) : error ? (
            <div className="error-message">{error}</div>
          ) : medicalHistory.length > 0 ? (
            <>
              {medicalHistory.map((item: IMedList, index) => (
                <MedList medlist={item} key={item.id || index} />
              ))}

              {pagination.totalPages > 1 && (
                <div className="pagination-container">
                  <Pagination
                    currentPage={pagination.currentPage}
                    totalPages={pagination.totalPages}
                    onPageChange={handlePageChange}
                  />
                </div>
              )}
            </>
          ) : (
            <div className="no-data-message">Нет истории медосмотров</div>
          )}
        </div>
      </div>
    </div>
  );
}

// Делаем driverProfileId необязательным параметром
MedInfoCard.defaultProps = {
  driverProfileId: '',
};

export default MedInfoCard;
